<div *ngIf="inputForm">
  <form [formGroup]="inputForm">
    <form-row>
      <mat-form-field appearance="outline" name="supplyDate" fxFlex>
        <mat-label>Inbetriebsetzung Datum:</mat-label>
        <input
          matInput
          formControlName="commissioningDate"
          [matDatepicker]="comDate"
          placeholder="Inbetriebsetzung Datum:" />
        <mat-datepicker-toggle matSuffix [for]="comDate"></mat-datepicker-toggle>
        <mat-datepicker #comDate></mat-datepicker>
      </mat-form-field>
    </form-row>
    <button
      *ngIf="hasEditPermission"
      (click)="handleCalculateCategories()"
      color="primary"
      mat-raised-button
      style="margin-bottom: 1rem">
      Kategorien nach Datum ermitteln
    </button>
  </form>
</div>

<div *ngIf="compensationCategories && compensationCategories.length > 0">
  <section>
    <app-value-with-label
      *ngIf="feederContract.commissioningDate"
      [label]="'Inbetriebesetzungsdatum:'"
      [value]="feederContract.commissioningDate | date : 'd.MMM.y'"></app-value-with-label>
  </section>
  <section>
    <h3 *ngIf="!inputForm">
      <span>
        <ng-container *ngIf="compensationCategories.length == 1">Vergütungskategorie</ng-container>
        <ng-container *ngIf="compensationCategories.length > 1">Vergütungskategorien</ng-container>
      </span>
    </h3>

    <ng-container *ngFor="let compensationCategory of compensationCategories">
      <section fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <h4>{{ compensationCategory.name }}</h4>
          Leistungsbereich:
          <b>{{ compensationCategory.powerRange | compCatPowerRangePipe }}</b>
          <br />
          Vergütung:
          <b>{{ compensationCategory.compensationAmount }} Ct/kWh</b>
          <br />
          Volleinspeisung:
          <b>{{ compensationCategory.isFullFeed ? 'Ja' : 'Nein' }}</b>
        </div>
        <button
          *ngIf="hasEditPermission && !disable"
          (click)="handleRemoveCategory(compensationCategory)"
          mat-icon-button
          matSuffix
          color="warn"
          [style]="{ 'margin-right': '2rem' }">
          <mat-icon>delete</mat-icon>
        </button>
      </section>
    </ng-container>
  </section>
  <button
    *ngIf="hasEditPermission && !disable"
    (click)="openCategorySelectionModal()"
    color="primary"
    mat-raised-button
    style="margin-bottom: 1rem">
    <mat-icon>add</mat-icon>
    Weitere Kategorien hinzufügen
  </button>
</div>
